import { css } from 'lit';
/* eslint-disable promise/prefer-await-to-then */
/* eslint-disable no-use-before-define */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { HttpStatusCode } from '@constants';
import { APIRequestReturn } from '../../redux/APIRequest';
import store, { ThunkActionRoot } from '../../redux/redux-store';
import { getWorkZoneRequests } from '../../redux/rem/rem-actions-event';

//	get all event imports

let WorkZonesPollingTimeout: number;
let WorkZonesLastAPIRequestReturn: APIRequestReturn;

function WorkZonesPollingVisibilityChangeHandler() {
	if (!document.hidden) {
		// eslint-disable-next-line promise/prefer-await-to-then
		void store.dispatch(getWorkZoneRequests()).then((ret) => {
			WorkZonesLastAPIRequestReturn = ret;
			return ret;
		});
	}
}
export const stopPollingWorkZones = (autoAbort = true): void => {
	window.clearInterval(WorkZonesPollingTimeout);
	if (autoAbort && WorkZonesLastAPIRequestReturn) {
		WorkZonesLastAPIRequestReturn.abortController?.abort();
	}
	document.removeEventListener('visibilitychange', WorkZonesPollingVisibilityChangeHandler);
};

const POLLING_DELAY_PADDING_MS = 2000;

export const startPollingWorkZones =
	(pollingDelayMs: number, pollImmediately = true): ThunkActionRoot<Promise<void>> =>
	async (dispatch, getState): Promise<void> => {
		const { eventsLastPolled } = getState().rem;

		window.clearInterval(WorkZonesPollingTimeout);

		if (
			pollImmediately ||
			!eventsLastPolled ||
			Date.now() - eventsLastPolled > pollingDelayMs + POLLING_DELAY_PADDING_MS
		) {
			WorkZonesLastAPIRequestReturn = await dispatch(getWorkZoneRequests());
		}

		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		WorkZonesPollingTimeout = window.setInterval(async (): Promise<void> => {
			WorkZonesLastAPIRequestReturn = await dispatch(getWorkZoneRequests());
			if (
				WorkZonesLastAPIRequestReturn.response?.status === HttpStatusCode.UNAUTHORIZED ||
				WorkZonesLastAPIRequestReturn.response?.status === HttpStatusCode.FORBIDDEN
			) {
				stopPollingWorkZones();
			}
		}, pollingDelayMs);
		document.addEventListener('visibilitychange', WorkZonesPollingVisibilityChangeHandler);
	};
